<template>  <div class="check-section">
    <h3>בדיקת נגישות סרטון</h3>
    <div class="check-result">
      <div :class="['status-badge', statusClass]">{{ statusText }}</div>
      <div class="url-info">{{ url }}</div>
      <div class="check-message">{{ checkMessage }}</div>
      <div v-if="checkStatus === 'blocked'" class="blocked-warning">
        <div class="warning-icon">⚠️</div>
        <p>לא ניתן להעלות סרטונים חסומים. אנא נסה סרטון אחר שאינו חסום בסינון האינטרנט שלך.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetfreeChecker',
  props: {
    url: {
      type: String,
      required: true
    },
    checking: {
      type: Boolean,
      default: false
    },
    checkStatus: {
      type: String,
      default: null
    },
    checkMessage: {
      type: String,
      default: ''
    }
  },
  computed: {    statusText() {
      if (this.checking) return 'בודק...';
      if (!this.checkStatus) return 'בודק...';
      if (this.checkStatus === 'accessible') return 'נגיש';
      if (this.checkStatus === 'blocked') return 'לא נגיש';
      return 'לא ידוע';
    },
    statusClass() {
      if (this.checking) return 'status-unknown';
      if (!this.checkStatus) return 'status-unknown';
      if (this.checkStatus === 'accessible') return 'status-open';
      if (this.checkStatus === 'blocked') return 'status-blocked';
      return 'status-unknown';
    }
  }
}
</script>

<style scoped>
.check-section {
  margin: 15px 0;
  padding: 15px;
  border-radius: 8px;
  background-color: #f7f9fc;
  border: 1px solid #dfe1e5;
}

.status-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 20px;
  font-weight: 500;
  margin: 10px 0;
}

.status-open {
  background-color: #e6f4ea;
  color: #0d652d;
}

.status-blocked {
  background-color: #fce8e6;
  color: #c5221f;
}

.status-unknown {
  background-color: #e8eaed;
  color: #5f6368;
}

.url-info {
  margin: 10px 0;
  font-size: 14px;
  word-break: break-all;
  background-color: #f1f3f4;
  padding: 8px;
  border-radius: 4px;
}

.check-message {
  margin-top: 10px;
  font-size: 14px;
}

.blocked-warning {
  margin-top: 15px;
  background-color: #feedef;
  border: 1px solid #f8d7d9;
  border-radius: 6px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
}

.warning-icon {
  font-size: 20px;
  margin-left: 10px;
}

.blocked-warning p {
  margin: 0;
  color: #721c24;
  font-weight: 500;
  line-height: 1.4;
}
</style>